import o from "./extends3.mjs";
import C from "./objectWithoutPropertiesLoose3.mjs";
import * as M from "react";
import { PickersModalDialog as B } from "./PickersModalDialog.mjs";
import { onSpaceOrEnter as E } from "./utils7.mjs";
import { useUtils as H } from "./useUtils.mjs";
import { jsxs as K, jsx as d } from "react/jsx-runtime";
import N from "./useId.mjs";
import { usePicker as U } from "./usePicker.mjs";
import { useSlotProps as W } from "./useSlotProps.mjs";
import { PickersLayout as q } from "./PickersLayout.mjs";
import G from "./useForkRef.mjs";
import { LocalizationProvider as J } from "./LocalizationProvider.mjs";
const Q = ["props", "getOpenDialogAriaText"], uo = (u) => {
  var c, m, f;
  let {
    props: s,
    getOpenDialogAriaText: v
  } = u, F = C(u, Q);
  const {
    slots: t,
    slotProps: e,
    className: O,
    sx: S,
    format: h,
    formatDensity: w,
    timezone: I,
    name: T,
    label: P,
    inputRef: g,
    readOnly: n,
    disabled: b,
    localeText: D
  } = s, _ = H(), x = M.useRef(null), i = N(), y = (c = e == null || (m = e.toolbar) == null ? void 0 : m.hidden) != null ? c : !1, {
    open: L,
    actions: a,
    layoutProps: V,
    renderCurrentView: $,
    fieldProps: k
  } = U(o({}, F, {
    props: s,
    inputRef: x,
    autoFocusView: !0,
    additionalViewProps: {},
    wrapperVariant: "mobile"
  })), R = t.field, l = W({
    elementType: R,
    externalSlotProps: e?.field,
    additionalProps: o({}, k, y && {
      id: i
    }, !(b || n) && {
      onClick: a.onOpen,
      onKeyDown: E(a.onOpen)
    }, {
      readOnly: n ?? !0,
      disabled: b,
      className: O,
      sx: S,
      format: h,
      formatDensity: w,
      timezone: I,
      label: P,
      name: T
    }),
    ownerState: s
  });
  l.inputProps = o({}, l.inputProps, {
    "aria-label": v(k.value, _)
  });
  const j = o({
    textField: t.textField
  }, l.slots), z = (f = t.layout) != null ? f : q, A = G(x, l.inputRef, g);
  let p = i;
  y && (P ? p = `${i}-label` : p = void 0);
  const r = o({}, e, {
    toolbar: o({}, e?.toolbar, {
      titleId: i
    }),
    mobilePaper: o({
      "aria-labelledby": p
    }, e?.mobilePaper)
  });
  return {
    renderPicker: () => /* @__PURE__ */ K(J, {
      localeText: D,
      children: [/* @__PURE__ */ d(R, o({}, l, {
        slots: j,
        slotProps: r,
        inputRef: A
      })), /* @__PURE__ */ d(B, o({}, a, {
        open: L,
        slots: t,
        slotProps: r,
        children: /* @__PURE__ */ d(z, o({}, V, r?.layout, {
          slots: t,
          slotProps: r,
          children: $()
        }))
      }))]
    })
  };
};
export {
  uo as useMobilePicker
};
//# sourceMappingURL=useMobilePicker.mjs.map
